import { Dialog, DialogHeader, DialogBody, Button} from "@material-tailwind/react";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import AddDrugRecord from "../CRUDPage/AddDrugRecord";
import AddExamineRecord from "../CRUDPage/AddExamineRecord";
import ListAllRecord from "../RecordPage/ListAllRecord";
import ListAllDrug from "../RecordPage/ListAllDrug";
import RecordChart from "../RecordPage/RecordChart";
import AddPatientData from "../CRUDPage/AddPatientData";

let routelist = {patient_data: <AddPatientData></AddPatientData>,adddrugrecord:<AddDrugRecord></AddDrugRecord>, addrecord:<AddExamineRecord></AddExamineRecord>, list_record:<ListAllRecord></ListAllRecord>, list_drug_record:<ListAllDrug></ListAllDrug>, test_chart:<RecordChart></RecordChart>};
let headerText = {patient_data: "更改病患資料",adddrugrecord:"用藥表單", addrecord:"檢查表單", list_record:"檢查紀錄", list_drug_record:"用藥清單", test_chart:"趨勢圖"};

function RouteDialog({isOpen, targetRoute, handleDialogClose, patientData}){
    if(patientData != null ){
        // console.log("route:",patientData)
        routelist["patient_data"] = <AddPatientData patientData={patientData}></AddPatientData>
        routelist["adddrugrecord"] = <AddDrugRecord patientData={patientData}></AddDrugRecord>;
        routelist["addrecord"] = <AddExamineRecord patientData={patientData}></AddExamineRecord>
        routelist["list_record"] = <ListAllRecord patientData={patientData}></ListAllRecord>;
        routelist["list_drug_record"] = <ListAllDrug patientData={patientData}></ListAllDrug>;
        routelist["test_chart"] = <RecordChart patientData={patientData}></RecordChart>;

    }
    
    return(
        // bg-[#4e4e4e22]  backdrop-blur-sm h-3/4
        <div className="text-xl">
            <Dialog open={isOpen} handler={handleDialogClose} className="overflow-auto bg-[#D9EFEC] h-full">
                <DialogHeader className=" justify-end"><Button onClick={() => handleDialogClose()} className=" text-base">Close</Button></DialogHeader>
                <DialogHeader className=" flex justify-center font-bold text-2xl">{headerText[targetRoute]}</DialogHeader>
                <DialogBody className=" overflow-auto w-full h-full">
                    <ToastContainer 
                        position="top-left"
                        autoClose={2000}
                    ></ToastContainer>
                    {routelist[targetRoute]}
                </DialogBody>
            </Dialog>
        </div>
    )
}

export default RouteDialog;